<template>
  <div class="details">
    <template v-if="loading">
      <template v-if="summer">
        <h2>{{ summerPage.title }}</h2>
        <div v-html="summerPage.content"></div>
      </template>
      <template v-else>
        <h2>{{ familyPage.title }}</h2>
        <div v-html="familyPage.content"></div>
      </template>
      <div class="clearfix">
        <b-link
          class="back"
          :to="{ name: summer ? 'summer-carnival' : 'family-day-2019' }"
          >{{ $lang("TITLE_RETURN_INDEX") }}</b-link
        >
      </div>
    </template>
    <template v-else>
      <b-spinner variant="primary" label="Spinning"></b-spinner>
    </template>
  </div>
</template>

<script>
export default {
  data() {
    return {
      summer: true,
      familyPage: {},
      summerPage: {},
      loading: false
    };
  },
  computed: {
    sport() {
      let sport = this.$route.params.sports;
      if (sport === "summer-carnival") {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    getPage() {
      this.loading = false;
      this.$apis.user
        .getPage()
        .then(resp => {
          this.familyPage = resp.data["family-day-2019-info-page"];
          this.summerPage = resp.data["summer-carnival-2019-info-page"];
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.loading = true;
        });
    },
    getParams() {
      let sport = this.$route.params.sports;
      if (sport === "summer-carnival") {
        this.summer = true;
      } else {
        this.summer = false;
      }
    }
  },
  created() {
    this.getParams();
  }
};
</script>
